module.exports = __webpack_public_path__ + "img/retail_mobile.a381c831.jpg";